import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

function AddExpenseReport() {
    const navigate = useNavigate();
    const location = useLocation(); // Get the state passed when navigating from Inventory

    const { vin } = location.state || {}; // Extract the VIN from the state, if passed

    const handleScanCopy = async (event) => {
        if (!event.target.files || !event.target.files[0]) return;

        const file = event.target.files[0];
        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/process-image`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                const errorText = await response.text(); // Get the full error response
                console.error('Server response:', errorText);
                throw new Error('Failed to process image');
            }

            const data = await response.json();
            
            navigate('/enter-details-manually', { 
                state: { 
                    vin,
                    scannedData: {
                        date: data.date,
                        amount: data.amount,
                        description: data.description,
                        category: data.category
                    }
                } 
            });

        } catch (error) {
            console.error('Error processing image:', error);
        }
    };

    const handleEnterDetailsManually = () => {
        // Navigate to the "Enter Details Manually" page and pass the VIN
        navigate('/enter-details-manually', { state: { vin } });
    };

    return (
        <Container maxWidth="sm">
            <Box mt={5} textAlign="center">
                <Typography variant="h4" gutterBottom>
                    Add Expense Report
                </Typography>
                <input
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: 'none' }}
                    id="scan-button"
                    onChange={handleScanCopy}
                />
                <label htmlFor="scan-button">
                    <Button
                        variant="contained"
                        color="primary"
                        component="span"
                        sx={{ m: 2 }}
                    >
                        Scan Copy
                    </Button>
                </label>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleEnterDetailsManually}
                >
                    Enter Details Manually
                </Button>
            </Box>
        </Container>
    );
}

export default AddExpenseReport;